import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { IonIcon } from '@ionic/react';
import { Card, Tab, Tabs } from 'react-bootstrap';
import { sendOutline, trashOutline } from 'ionicons/icons';
import 'react-datepicker/dist/react-datepicker.css';
import VnButton from '@ui/components/VnButton';
import { formatDMY, getCurrentISOformatDMY, handleRolePermission } from '@infrastructure/helpers';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { createProgressNotesByIdAsync, deleteProgressNotesByIdAsync, getAllProgressNotesByOrderIdAsync } from '@application/features/orders/orderThunk';
import './style.css';
import { Permission, PermissionType } from '@application/common/enums/role-permission';
import { addErrorNotification } from '@application/features/common/notificationSlice';
import { resetTimer, setModuleLock, unsetModuleLock } from '@application/features/workorders/workorderSlice';
import { VisserModule } from '@application/common/enums/visser-module';
import { updateModulePermissionsStatusAsync } from '@application/features/workorders/workorderThunk';
const InfoNotesCard = ({ formData, errors, onFieldChange, onCalendarChange, disableRecord }) => {
    const dispatch = useAppDispatch();
    const { currentUser } = useAppSelector((state) => state.auth);
    const [addedProgressNote, setAddedProgressNote] = useState('');
    const [currentUserLastProgreeNoteId, setCurrentUserLastProgreeNoteId] = useState(0);
    const [isProgressNoteDisabled, setIsProgressNoteDisabled] = useState(false);
    const [progressNotesList, setProgressNotesList] = useState([]);
    const handleProgressNoteInputChange = (event) => {
        setAddedProgressNote(event.target.value);
    };
    useEffect(() => {
        if (formData?.id > 0) {
            getAllProgressNotes(formData?.id);
        }
        else {
            setIsProgressNoteDisabled(true);
        }
    }, [dispatch, formData.id]);
    const handelProgressNoteDeleteClick = async (noteid) => {
        var moduleLockStatus = await checkModulelock();
        if (formData?.id > 0 && noteid > 0 && !isProgressNoteDisabled && moduleLockStatus == false) {
            setIsProgressNoteDisabled(true);
            dispatch(deleteProgressNotesByIdAsync({
                id: noteid,
                orderId: formData?.id,
                note: ''
            }))
                .unwrap()
                .then((res) => {
                if (formData?.id > 0) {
                    getAllProgressNotes(formData?.id);
                }
            });
        }
    };
    const handleProgressNoteButtonClick = async () => {
        if (addedProgressNote.trim() && formData?.id > 0 && !isProgressNoteDisabled) {
            setIsProgressNoteDisabled(true);
            var moduleLockStatus = await checkModulelock();
            if (moduleLockStatus == false) {
                dispatch(createProgressNotesByIdAsync({
                    orderId: formData?.id,
                    note: addedProgressNote
                }))
                    .unwrap()
                    .then((res) => {
                    setAddedProgressNote('');
                    if (formData?.id > 0) {
                        getAllProgressNotes(formData?.id);
                    }
                });
            }
        }
    };
    const getAllProgressNotes = (workOrderId) => {
        dispatch(getAllProgressNotesByOrderIdAsync(workOrderId)).then((res) => {
            if (res?.payload && Array.isArray(res.payload)) {
                const lastNoteIdForCurrentUser = res.payload
                    .filter((note) => currentUser &&
                    currentUser.createdBy === note.createdBy &&
                    note.created &&
                    formatDMY(note.created?.toString()) === getCurrentISOformatDMY())
                    .map((note) => note.id)
                    .pop();
                setCurrentUserLastProgreeNoteId(lastNoteIdForCurrentUser ?? 0);
                setProgressNotesList(res.payload);
            }
            else {
                setCurrentUserLastProgreeNoteId(0);
            }
            scrollProgressNoteToBottom();
            setIsProgressNoteDisabled(false);
        });
    };
    const progressNotesRef = useRef(null);
    const scrollProgressNoteToBottom = () => {
        const container = progressNotesRef.current;
        if (container && container.scrollHeight > 0) {
            container.scrollTo({
                top: container.scrollHeight,
                behavior: 'smooth'
            });
        }
    };
    const checkModulelock = async () => {
        if (formData?.id) {
            dispatch(resetTimer());
            var moduleLockRequestData = {
                moduleId: VisserModule.Bestellingen,
                recordId: formData.id
            };
            try {
                const res = await dispatch(updateModulePermissionsStatusAsync(moduleLockRequestData)).unwrap();
                if (res.isModuleAlreadyLocked) {
                    dispatch(setModuleLock());
                    return true;
                }
                dispatch(unsetModuleLock());
                return false;
            }
            catch (error) {
                dispatch(unsetModuleLock());
                return false;
            }
        }
        return false;
    };
    return (_jsx(Card, { className: 'vn-Info-Order-Notes-Card vn-Card-Component mt-4', children: _jsx(Card.Body, { className: 'd-flex flex-column mt-2 vn-GeneralTab-cardbody', children: _jsx(Tabs, { className: 'vn-Order-TabHeader', children: _jsx(Tab, { eventKey: 'NotesTab', title: 'Voortgang notities', children: _jsxs("div", { className: 'd-flex flex-column', children: [_jsxs("div", { ref: progressNotesRef, className: 'vn-ordertab-chat-card-contaner', children: [progressNotesList &&
                                        progressNotesList.map((note, index) => (_jsx(Card, { className: 'vn-GeneralTab-Card', children: _jsxs(Card.Body, { children: [_jsxs("div", { className: 'vn-Card-design', children: [_jsxs("div", { children: [_jsx("img", { src: 'images/user.png', alt: 'app-user', className: 'vn-Card-Image' }), _jsxs("p", { className: 'vn-Card-Text', children: [note.createdByFirstName, " ", note.createdByLastName] })] }), _jsx("div", { className: 'vn-Card-Span', children: _jsxs("span", { className: 'vn-General-Tab-Span', children: [_jsxs("span", { children: [" ", formatDMY(note.created?.toString())] }), currentUserLastProgreeNoteId === note.id ? (_jsx("span", { onClick: () => {
                                                                                if (handleRolePermission(Permission.BESTELLINGEN, PermissionType.Update) &&
                                                                                    !disableRecord) {
                                                                                    handelProgressNoteDeleteClick(note.id);
                                                                                }
                                                                                else {
                                                                                    dispatch(addErrorNotification('Toegang Geweigerd'));
                                                                                }
                                                                            }, children: _jsx(IonIcon, { className: 'vn-progress-note-delete', icon: trashOutline }) })) : null] }) })] }), _jsx(Card.Text, { className: 'vn-Card-Message', children: note.note })] }) }, index))), _jsx("div", {})] }), _jsxs("div", { className: 'input-group vn-ordertab-chat-input-group ml-14', children: [_jsx("input", { type: 'text', className: 'form-control vn-GeneralTab-chat-input-field', placeholder: 'Typ hier', "aria-label": "Recipient's username with two button addons", "aria-describedby": 'button-addon4', onChange: handleProgressNoteInputChange, value: addedProgressNote, onKeyDown: (event) => {
                                            if (event.key === 'Enter') {
                                                event.preventDefault();
                                                if (handleRolePermission(Permission.BESTELLINGEN, PermissionType.Update) && !disableRecord) {
                                                    handleProgressNoteButtonClick();
                                                }
                                                else {
                                                    dispatch(addErrorNotification('Toegang Geweigerd'));
                                                }
                                            }
                                        } }), _jsx("div", { className: 'input-group-append', id: 'button-addon4', children: _jsx(VnButton, { type: 'button', customClassName: 'vn-search-button', mode: 'primary', size: 'sm', icon: sendOutline, onClick: () => {
                                                if (handleRolePermission(Permission.BESTELLINGEN, PermissionType.Update)) {
                                                    handleProgressNoteButtonClick();
                                                }
                                                else {
                                                    dispatch(addErrorNotification('Toegang Geweigerd'));
                                                }
                                            }, isDisabled: !isProgressNoteDisabled && disableRecord }) })] })] }) }) }) }) }));
};
export default InfoNotesCard;
